import { LitElement, html, css, render } from 'lit';

import { msg } from '@lit/localize';
import { search }  from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
import { arrowBack } from '../../utilities/icons';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInLocationSearch extends LitElement {
    static properties = {
        name: {type:String},
        loading: {type:Boolean,state:true},
        restUrl: {type:String},
        nonce: {type:String},
        locations: {type:Array,state:true},
        location: {type:Object,state:true},
        noLocation : {type:Boolean,state:true},
        freshlyCleared: {type:Boolean,state:true},
        locationUrl: {type:String},
        locationName: {type:String},
        value: {type:String},
    }
    constructor() {
        super();
    }

    async connectedCallback() {
       super.connectedCallback();
       this.eventManager = new EventManager(this);
        if(this.value){
            await this._fetchLocation(this.value);
        }
    }

    updated(changedProperties) {
        if(changedProperties.has('location')){
            this.eventManager.emit(`location-selected-${this.name}`, this.location);
        }
    }

    createRenderRoot() { 
        return this;
    }

    render(){
        let main;
        if(this.location){
            main = html`
                <div class="selected-location">
                    ${this.location.location_data.photo1 ? html`<img src="${this.location.location_data.photo1.publicUrl}" alt="${this.location.location_data.name} image" />` : html`<div class="placeholder-image" aria-label="${msg('No image available')}"></div>`}
                    <h4>${this.location.location_data.name}</h4>
                    <button class="button" @click=${(e) => {this._selectLocation(null,e);this.freshlyCleared = true;}}>${msg('Change location')}</button>
                </div>
            `;
        }
        else if (this.noLocation||this.locationUrl){
            main = html`
                <div class="no-location">
                    <label for="locationUrl">${msg(`Please add a link to the access information page for your touring location`)}</label>
                    <input type="url" id="locationUrl" name="locationUrl" placeholder="${msg(`Please add a link to the access information page for your touring location`)}" value="${this.locationUrl ?? ''}" aria-required="true" @blur=${this._slotURLChangeOnline}/>

                    <label for="locationName">${msg(`Please add a name for your touring location`)}</label>
                    <input type="text" id="locationName" name="locationName" placeholder="${msg(`Please add a name for your touring location`)}" value="${this.locationName ?? ''}" @input=${this._handleLocationNameChange}/>
                    <button class="back" @click=${(e) => {e.preventDefault(); this.noLocation=false; this.locationUrl='', this.locationName='', this.freshlyCleared = true;}}><span aria-hidden="true">${arrowBack}</span>${msg('Search again')}</button>
                </div>
            `;
        }
        else{
            main=html`
                <div class="allin-location-search-form ${this.loading?"loading":""}" ?aria-busy=${this.loading} >
                    <div class="searchboxes">
                        <div class="searchbox">
                            <label for="allin-listings-search">${msg("Search your touring location")}</label>
                            ${search}
                            <input type="text" id="allin-listings-search" name="search" value="${this.search}" @keydown=${this._handleKeydown}/>
                        </div>
                        <button class="button" ?disabled=${this.loading} @click=${this._handleSubmit}>${msg(`Search`)}</button>
                    </div>
                    <div class="message" aria-live="polite"></div>
                </div>
            `;
        }
        let locationsList;
        if(this.locations && this.locations.length>0){
            locationsList = html`
                <ul class="locations-list">
                ${
                    this.locations.map((loc)=>html`
                        <li class="location">
                            ${loc.photo1 ? html`<img src="${loc.photo1.publicUrl}" alt="${loc.name} image" />` : html`<div class="placeholder-image" aria-label="${msg('No image available')}"></div>`}
                            <h4>${loc.name}</h4>
                            <button type="button" @click=${(e) => this._selectLocation(loc,e)}>${msg('Select')} <span class="screen-reader-text">${loc.name}</span></button>
                        </li>
                    `)
                }
                </ul>
                <div class="button_group button-group">
                    <button class="button" @click=${(e) => { e.preventDefault(); this.locations = []; this.freshlyCleared = true; }}>${msg('Clear search results')}</button>
                    <button class="button" @click=${this._handleNoLocationFound }>${msg(`I can't find the location`)}</button>
                </div>
             `;   
        }
        else if(this.locations && this.locations.length===0 && !this.loading && !this.noLocation &&!this.locationUrl&&!this.location&&!this.freshlyCleared && !this.locationName){
            locationsList = html`
                <p>${msg('No locations found. Please try a different search term.')}</p>
                 <div class="button_group button-group">
                    <button class="button" @click=${(e) => { e.preventDefault(); this.locations = []; this.freshlyCleared = true; }}>${msg('Clear search results')}</button>
                    <button class="button" @click=${this._handleNoLocationFound }>${msg(`I can't find the location`)}</button>
                </div>
            `;
        }

        return html`
            <input type="hidden" name="locationId" .value=${this.location ? this.location.id : ''} />
            <input type="hidden" name="locationName" .value=${this.locationName ?? ''} />
            <div class="bg">
                ${main}
                ${locationsList}
            </div>
        `;
    }

    async _handleSubmit(e){
        e.preventDefault();
        this.loading = true;
        this.freshlyCleared = false;
        const search = this.renderRoot.querySelector('#allin-listings-search').value;
        const messageEl = this.renderRoot.querySelector('.message');
        if(messageEl){
            messageEl.textContent = '';
        }
        if(!search || search.trim()==='' || search.trim().length<3){
            this.loading = false;
            if(messageEl){
                messageEl.textContent = msg('Please enter at least 3 characters to search.');
            }
            return;
        }
        const params = new URLSearchParams();
        if(search) params.append('search', search);
        if(this._pageNumber) params.append('pageNumber', this._pageNumber);
        try{
            const response = await fetch(`${this.restUrl}?action=get_locations&${params.toString()}`,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });

            //show logged out modal if session has expired
            if(response.status === 403){
                handle403s();
                return;
            }

            const data = await response.json();

            if(data){
                this.locations = data.data;
            }
        }
        catch(error){
            console.error('Error fetching locations:', error);
        }
        finally{
            this.loading = false;
        }
    }

    _selectLocation(location,e){
        e.preventDefault();
        this.freshlyCleared = false;
        if(location){
            this.location = {id: location.id, location_data:location};
        }
        else{
            this.location = null;
        }
        this.locations = [];
    }

    _handleKeydown(e){
        if(e.key === 'Enter'){
            e.preventDefault();
            this._handleSubmit(e);
        }
    }

    _slotURLChangeOnline(e) {
        const value = e.target.value?.trim();
        if (value && !/^https?:\/\//i.test(value)) {
            e.target.value = `https://${value}`;
        }
    }

    _fetchLocation = async (locationId) => {
        this.loading = true;
        try {
            const response = await fetch(`${this.restUrl}?action=get_location&location_id=${locationId}`, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });

            //show logged out modal if session has expired
            if(response.status === 403){
                handle403s();
                return;
            }

            const data = await response.json();
            if(data){
                this.location = {id: data.id, location_data: data};
            }
        }
        catch(error){
            console.error('Error fetching location:', error);
        }
        finally{
            this.loading = false;
        }
    }

    _handleNoLocationFound(e){
        e.preventDefault();
        this.noLocation=true; 
        this.freshlyCleared = false;
        this.locations=[];
        this.eventManager.emit(`no-location-found-${this.name}`);
    }

    // New handler for LocationName field in location Search for Touring event
    _handleLocationNameChange(e) {
        this.locationName = e.target.value;
    }
}